import { useState } from "react";
import { Button } from "@/shared/components/shadcn/Button";
import { TextArea } from "@/shared/components/shadcn/TextArea";
import { ConfirmationDialog } from "@/shared/components/ui/ConfirmationDialog";
import { FormField } from "@/shared/components/ui/FormField";

interface UnsupportedDefinitionProps {
  definition: string;
  message: string;
  onReset?: () => void;
}

export function UnsupportedDefinition({ definition, message, onReset }: UnsupportedDefinitionProps) {
  const [confirming, setConfirming] = useState(false);
  return (
    <section aria-label="Unsupported definition" className="space-y-4">
      <p role="status" className="text-sm text-muted-foreground">{message}</p>
      <FormField id="form-definition" label="Raw definition" description="Read-only. Reset explicitly to start a new visual design.">
        <TextArea value={definition} readOnly rows={14} spellCheck={false} className="font-mono" />
      </FormField>
      {onReset && <Button variant="outline" onClick={() => setConfirming(true)}>Reset to blank builder form</Button>}
      <ConfirmationDialog open={confirming} onOpenChange={setConfirming} title="Start a blank builder form?"
        description="This replaces the definition in your editor. Nothing changes in the database until you explicitly save a new version. Previous saved versions remain retained, but there is no version-history screen."
        confirmLabel="Reset definition" dismissLabel="Keep original" destructive
        onConfirm={() => { onReset?.(); setConfirming(false); }} />
    </section>
  );
}
